import { common } from './common'

export const staging = {
    ...common
}